export const supplierCatalogItemDefaultValues = {
  catalogItemUnitOfMeasure: 'Piece',
  catalogItemQuantityPerUnitOfMeasure: 1,
  catalogItemCurrency: 'NZD',
  catalogItemUnitPrice: 0.0,
  catalogItemPricePerUnitOfMeasure: 0.0,
  catalogItemImportedMergedPrice: 0.0,
};
